const stack = document.querySelector(".stack");
const cards = Array.from(stack.querySelectorAll(".stack-card"));

function setupInitialPosition() {
  cards.forEach((card, index) => {
    if (index === 0) {
      card.style.transform = "translate(0px, 0px) rotate(0deg)";
      card.style.transformOrigin = "left";
      card.style.zIndex = 30;
    } else if (index === 1) {
      card.style.transform = "translate(-30px, -5px) rotate(-8deg)";
      card.style.transformOrigin = "left";
      card.style.zIndex = 20;
    } else {
      card.style.transform = "translate(-60px, 60px) rotate(-16deg)";
      card.style.transformOrigin = "left";
      card.style.zIndex = 10;
    }
  });
}

function rotateCards() {
  const currentCard = cards[0];
  currentCard.style.transition = "transform 0.5s ease";
  currentCard.style.transform = "translate(100px, 0px) rotate(20deg)";

  setTimeout(() => {
    currentCard.style.transition = "transform 0.5s ease";
    currentCard.style.transform = "translate(-60px, 60px) rotate(-16deg)";
    currentCard.style.zIndex = 10;

    const nextCard = cards[1];
    nextCard.style.transition = "transform 0.5s ease";
    nextCard.style.transform = "translate(0px, 0px) rotate(0deg)";
    nextCard.style.zIndex = 30;

    const lastCard = cards[2];
    lastCard.style.transition = "transform 0.5s ease";
    lastCard.style.transform = "translate(-30px, -5px) rotate(-8deg)";
    lastCard.style.zIndex = 20;

    cards.push(cards.shift());
    setupInitialPosition();
  }, 500);
}

export function setupStackCard(timeout = 2000) {
  const styles = window.getComputedStyle(stack);

  if (styles.getPropertyValue("display") === "none") return;

  setupInitialPosition();

  setInterval(rotateCards, timeout);
}
